import { Cookie } from '@dtx-company/true-common/src/types/cookies'
import { FRONTEGG_AUTH_HEADER, FRONTEGG_LOGOUT_ROUTE } from './constants'
import { clearAccessTokenCookie } from './clearAccessTokenCookie'
import { clearImpersonationAccessTokenCookie } from './clearImpersonationAccessTokenCookie'
import { deleteCookie } from '@dtx-company/true-common/src/utils/cookies/cookies.utils'
import { logger } from '@dtx-company/logger'
import { notifyObserversOfLogout } from './notify'

const tokenName = 'ithacaToken'

export async function logout(shouldNotify = true): Promise<void> {
  try {
    const res = await fetch(FRONTEGG_LOGOUT_ROUTE, {
      method: 'POST',
      credentials: 'include',
      headers: FRONTEGG_AUTH_HEADER
    })
    if (!res.ok) {
      await logger.logFetchError(res, { technicalArea: 'authentication' })
    }
    localStorage?.removeItem(tokenName)
    deleteCookie(Cookie.TV_TOOL_COOKIE)
    deleteCookie(Cookie.FLOW_LEADS_COOKIE)
    await clearImpersonationAccessTokenCookie()
    await clearAccessTokenCookie()
    if (shouldNotify) {
      notifyObserversOfLogout()
    }
  } catch (e: unknown) {
    logger.logError(e, { technicalArea: 'authentication' })
  }
}
